/**
 * Holds the active workspace id that the API client attaches to every
 * workspace-scoped request as the `x-doneverse-workspace-id` header.
 *
 * The dashboard's workspace store owns the source of truth (state +
 * localStorage persistence) and the user-scoping rules; it registers a getter
 * here so the wretch middleware in api.ts can read the resolved value without
 * taking a React dependency.
 */

let activeWorkspaceIdGetter: () => string | null = () => null

export function setActiveWorkspaceIdGetter(getter: () => string | null): void {
  activeWorkspaceIdGetter = getter
}

export function getActiveWorkspaceId(): string | null {
  return activeWorkspaceIdGetter()
}
